export const useMobile = () => process.env.GATSBY_TARGET === 'mobile';

export const useTablet = () =>
  process.env.GATSBY_TARGET === 'tablet' || process.env.GATSBY_TARGET === 'mobile';
